import { render, staticRenderFns } from "./PerformingUpdateV2.vue?vue&type=template&id=cef13638&scoped=true&"
import script from "./PerformingUpdateV2.vue?vue&type=script&lang=js&"
export * from "./PerformingUpdateV2.vue?vue&type=script&lang=js&"
import style0 from "./PerformingUpdateV2.vue?vue&type=style&index=0&id=cef13638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef13638",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCol,VContainer,VIcon,VImg,VRow})
